var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto forgot-password-link forgot-password-link--image"},[_c('router-link',{attrs:{"to":_vm.forgotPasswordRoute}},[_c('img',{attrs:{"src":"/assets-proxy/images/forgot-password.png","alt":"パスワードをお忘れの方はコチラ"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }